// 11. HOOK POUR LA GESTION DES MODALES
// hooks/useModalsManager.ts
import { useState, useCallback } from 'react';

export const useModalsManager = () => {
  const [showAnalyseModal, setShowAnalyseModal] = useState(false);
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [showAnalysesModal, setShowAnalysesModal] = useState(false);
  const [showPrescriptionModalView, setShowPrescriptionModalView] = useState(false);

  const openAnalyseModal = useCallback(() => setShowAnalyseModal(true), []);
  const closeAnalyseModal = useCallback(() => setShowAnalyseModal(false), []);

  const openPrescriptionModal = useCallback(() => setShowPrescriptionModal(true), []);
  const closePrescriptionModal = useCallback(() => setShowPrescriptionModal(false), []);

  const openAnalysesModal = useCallback(() => setShowAnalysesModal(true), []);
  const closeAnalysesModal = useCallback(() => setShowAnalysesModal(false), []);

  const openPrescriptionModalView = useCallback(() => setShowPrescriptionModalView(true), []);
  const closePrescriptionModalView = useCallback(() => setShowPrescriptionModalView(false), []);

  const handleBackFromDocument = useCallback(
    (type: "analyses" | "prescription") => {
      
      if (type === "analyses") {
        closeAnalysesModal();
      } else if (type === "prescription") {
        closePrescriptionModalView();
      }
      // Forcer le défilement en haut de la page
      window.scrollTo(0, 0);
    },
    [closeAnalysesModal, closePrescriptionModalView]
  );

  return {
    // États
    showAnalyseModal,
    showPrescriptionModal,
    showAnalysesModal,
    showPrescriptionModalView,
    // Actions
    openAnalyseModal,
    closeAnalyseModal,
    openPrescriptionModal,
    closePrescriptionModal,
    openAnalysesModal,
    closeAnalysesModal,
    openPrescriptionModalView,
    closePrescriptionModalView,
    handleBackFromDocument,
  };
};